import React, { Children } from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
export function BonusSection() {
  const bonuses = [{
    title: 'Bono 1',
    label: '900 Etiquetas Escolares',
    image: 'https://cdn.magicpatterns.com/uploads/xqHir9u8buJgfm1pwHvKUT/image.png'
  }, {
    title: 'Bono 2',
    label: '240 Libritos para Colorear',
    image: 'https://cdn.magicpatterns.com/uploads/6D3wQdYnp7WqiEPByqWyzJ/image.png'
  }, {
    title: 'Bono 3',
    label: '+250 Invitaciones Digitales',
    image: 'https://cdn.magicpatterns.com/uploads/4c7o4pzXyJBPyhAYAMAn5C/image.png'
  }, {
    title: 'Bono 4',
    label: '12 Estilos de Flores de Papel',
    image: 'https://cdn.magicpatterns.com/uploads/uzfMHyZZ4PF6jWjqhrCNo3/image.png'
  }, {
    title: 'Bono 5',
    label: '130 Plantillas de Cajas',
    image: 'https://cdn.magicpatterns.com/uploads/99ZKP85JDWhuU5qakhtfu8/image.png'
  }, {
    title: 'Bono 6',
    label: '5 Pizarras de Cumpleaños',
    image: 'https://cdn.magicpatterns.com/uploads/eufsCxJXZnVXdLbSnzySCn/image.png'
  }, {
    title: 'Bono 7',
    label: '1200 Cake Toppers',
    image: 'https://cdn.magicpatterns.com/uploads/5arJX385vqkLnFbeg5qVYB/image.png'
  }, {
    title: 'Bono 8',
    label: 'Calendario de Organización de Fiesta',
    image: 'https://cdn.magicpatterns.com/uploads/hwVxGGGHbELaNoFisa12uB/image.png'
  }, {
    title: 'Bono 9',
    label: '+1000 Diseños para Sublimación',
    image: 'https://cdn.magicpatterns.com/uploads/hcTxHsaSPRLCtx3q1Fe4Rt/image.png'
  }, {
    title: 'Bono 10',
    label: 'Guía para Emprender',
    image: 'https://cdn.magicpatterns.com/uploads/5ZyUbyJN93pCeVKjCRhVGi/image.png'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.08
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        stiffness: 300
      }
    }
  };
  return <Section className="bg-mint-dark text-white" data-id="element-29">
      {/* Decorative top border */}
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-none z-0 rotate-180" data-id="element-30">
        <svg className="relative block w-full h-[50px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-31">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="fill-gray-50" data-id="element-32"></path>
        </svg>
      </div>

      <div className="text-center mb-10 relative z-10 pt-10" data-id="element-33">
        <h2 className="text-5xl md:text-7xl font-black uppercase tracking-tight mb-2 drop-shadow-md" data-id="element-34">
          Pero espera...
        </h2>
        <h3 className="text-5xl md:text-7xl font-script text-yellow-party drop-shadow-md transform -rotate-2 inline-block" data-id="element-35">
          ¡hay más!
        </h3>
      </div>

      <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
      once: true,
      margin: '-50px'
    }} className="grid grid-cols-2 gap-4 md:gap-6 max-w-2xl mx-auto relative z-10" data-id="element-36">
        {bonuses.map((bonus, index) => <motion.div key={index} variants={itemVariants} whileHover={{
        y: -4,
        scale: 1.02
      }} className="bg-white rounded-2xl overflow-hidden shadow-lg" data-id="element-37">
            {/* Image area */}
            <div className="aspect-[4/3] bg-partyPink-light flex items-center justify-center relative" data-id="element-38">
              {bonus.image ? <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover" data-id="element-39" /> : <span className="text-2xl md:text-3xl font-script text-partyPink" data-id="element-40">
                  {bonus.title}
                </span>}
            </div>
            {/* Label */}
            <div className="px-3 py-2.5 text-center" data-id="element-41">
              <p className="text-gray-700 font-semibold text-sm md:text-base" data-id="element-42">
                {bonus.label}
              </p>
              <p className="text-gray-400 line-through text-xs mt-1" data-id="element-43">
                Precio 17€
              </p>
              <p className="text-green-500 font-black text-sm uppercase" data-id="element-44">
                Hoy GRATIS
              </p>
            </div>
          </motion.div>)}
      </motion.div>

      <div className="text-center mt-8 relative z-10" data-id="element-45">
        <p className="text-2xl font-bold text-yellow-party bg-black/10 inline-block px-6 py-2 rounded-full" data-id="element-46">
          ¡Llévate todos estos bonos GRATIS hoy!
        </p>
      </div>
    </Section>;
}